









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { getFileLink } from '@/api/filestorage';
import {
  checkIsNewNotaryTariffName,
  converterFromPennyToRub,
  dateWithoutTime,
} from '@/utils/common';
import { StatementStatus } from '@/utils/statementStatus';
// eslint-disable-next-line no-unused-vars
import { IStatementStatusInfo } from '@/utils/types';
import { StatementParam } from '@/constants';

@Component({
  data: () => ({
    getFileLink,
    converterFromPennyToRub,
  }),
})
export default class StatusFieldRaw extends Vue {
  @Prop() data!: any;
  @Prop() statementStatusInfo!: IStatementStatusInfo;
  @Prop() currentStatusCode!: StatementStatus;

  get parseInnerData() {
    if (this.data.value) {
      if (typeof this.data.value === 'object') {
        return {
          ...this.data.value,
          label: this.data.label,
        };
      } else return this.data;
    } else return {};
  }

  get innerDataListIsEmpty() {
    let empty = true;
    if (this.parseInnerData.list) {
      for (let item in this.parseInnerData.list) {
        if (this.parseInnerData.list[item]) {
          empty = false;
        }
      }
    }
    return empty;
  }

  reformingValue(label: string, value: any) {
    if (Number.isInteger(value)) {
      value = converterFromPennyToRub(value);
    }
    if (['chargePayTillDate', 'date'].includes(label)) {
      value = dateWithoutTime(value);
    }

    return value;
  }

  mappingFieldName(fieldName: string) {
    let name = '';
    if (this.currentStatusCode === StatementStatus.IN_PROGRESS) {
      switch (fieldName) {
        case 'address':
          name = 'Адрес нотариуса';
          break;
        case 'surname':
          name = 'Фамилия нотариуса';
          break;
        case 'firstname':
          name = 'Имя нотариуса';
          break;
        case 'patronymic':
          name = 'Отчество нотариуса';
          break;
        case 'assistantSurname':
          name = 'Фамилия ВРИО';
          break;
        case 'assistantFirstname':
          name = 'Имя ВРИО';
          break;
        case 'assistantPatronymic':
          name = 'Отчество ВРИО ';
          break;
        case 'name':
          name = 'Наименование конторы ';
          break;
        case 'position':
          name = 'Должность';
          break;
        case 'registrationNum':
          name = 'Регистрационный номер Минюста';
          break;
        case 'phone':
          name = 'Телефон нотариальной конторы';
          break;
        case 'notaryDistrictId':
          name = 'Нотариальный округ';
          break;
      }
    }

    if (this.currentStatusCode === StatementStatus.AWAITING_PAYMENT) {
      switch (fieldName) {
        case 'SBPBankId':
          name = 'Код банка СБП';
          break;
        case 'SBPPhone':
          name = 'Номер телефона, привязанный к СБП';
          break;
        case 'SBPBankName' :
          name = 'Наименование банка СБП'
      }
    }

    if (
      [
        StatementStatus.AWAITING_PAYMENT,
        StatementStatus.SUSPENDED_DOCUMENTS_PROVIDED,
      ].includes(this.currentStatusCode)
    ) {
      switch (fieldName) {
        case 'chargeAmount':
          name =
            'Сумма, подлежащая уплате за совершение нотариального действия (рубли)';
          break;
        case 'chargePayTillDate':
          name = 'Дата, до которой необходимо оплатить';
          break;
        case 'id':
          name = 'Внутренний идентификатор';
          break;
        case 'notaryId':
          name = 'Нотариус';
          break;
        case 'bankName':
          name = 'Наименование банка';
          break;
        case 'bik':
          name = 'БИК';
          break;

        case 'checkingAccount':
          name = 'Расчетный счет';
          break;

        case 'correspondentAccount':
          name = 'Корреспондентский счёт';
          break;

        case 'purpose':
          name = 'Назначение платежа';
          break;

        case 'surname':
          name = 'Фамилия нотариуса';
          break;

        case 'firstname':
          name = 'Имя нотариуса';
          break;

        case 'patronymic':
          name = 'Имя нотариуса';
          break;

        case 'inn':
          name = 'ИНН нотариуса';
          break;

        case 'fio':
          name = 'ФИО нотариуса';
          break;

        case 'price':
          name = checkIsNewNotaryTariffName(this.statementStatusInfo?.extId)
            ? StatementParam.PRICE_NEW
            : StatementParam.PRICE;
          break;

        case 'multiplier':
          name = checkIsNewNotaryTariffName(this.statementStatusInfo?.extId)
            ? StatementParam.TH_NEW
            : StatementParam.TH;
          break;
        case 'privilegesDiscount':
          name = `Льгота: ${this.parseInnerData.list.privilegesName}`;
          break;

        case 'reason':
          name = `Причина отмены льготы`;
          break;

        case 'address':
          name = `Адрес нотариуса`;
          break;

        case 'assistantSurname':
          name = 'Фамилия ВРИО';
          break;

        case 'assistantFirstname':
          name = 'Имя ВРИО';
          break;

        case 'assistantPatronymic':
          name = 'Отчество ВРИО ';
          break;
        case 'assistantInn':
          name = 'ИНН ВРИО';
          break;
      }
    }
    if (this.currentStatusCode === StatementStatus.DISTRIBUTED) {
      switch (fieldName) {
        case 'fio':
          name = 'ФИО';
          break;
        case 'position':
          name = 'Должность';
          break;
        case 'notaryDistrictId':
          name = 'Нотариальный округ';
          break;
        case 'registrationNum':
          name = 'Регистрационный номер Минюста';
          break;
        case 'name':
          name = 'Наименование конторы';
          break;
        case 'phone':
          name = 'Телефон нотариальной конторы';
          break;

        case 'address':
          name = 'Адрес';
          break;
      }
    }

    if (this.currentStatusCode === StatementStatus.PROCESSED) {
      switch (fieldName) {
        case 'fio':
          name = 'ФИО нотариуса подписавшего документ или ВРИО';
          break;
        case 'registrationNum':
          name = 'Регистрационный номер Минюста';
          break;
        case 'id':
          name = 'ID заявления';
          break;
        case 'rudsId':
          name = 'Номер записи в РУДС';
          break;
        case 'date':
          name = 'Дата документа';
          break;
        case 'fssp':
          name = 'Код тер.отделения ФССП';
          break;

        case 'tariff':
          name = 'Тариф (сумма)';
          break;

        case 'th':
          name = 'ТХ (сумма)';
          break;

        case 'total':
          name = 'Итого (сумма)';
          break;

        case 'assistantSurname':
          name = 'Фамилия ВРИО';
          break;

        case 'assistantFirstname':
          name = 'Имя ВРИО';
          break;

        case 'assistantPatronymic':
          name = 'Отчество ВРИО';
          break;
      }
    }

    if (
      this.currentStatusCode === StatementStatus.SUSPENDED &&
      fieldName === 'suspendReason'
    ) {
      name = 'Причина отложения';
    }

    if (
      this.currentStatusCode === StatementStatus.REJECTED &&
      fieldName === 'rejectedReason'
    ) {
      name = 'Причина отказа';
    }

    if (
      this.currentStatusCode === StatementStatus.VALIDATION_ERROR &&
      fieldName === 'validationErrorDetails'
    ) {
      name = 'Описание ошибки';
    }

    if (this.currentStatusCode === StatementStatus.PROCESSED_FROM_FSSP) {
      switch (fieldName) {
        case 'documentCaseNumber':
          name = 'Номер материалов дела';
          break;
        case 'documentDate':
          name = 'Дата возбуждения ИП';
          break;
        case 'documentNumber':
          name = 'Номер исполнительного производства';
          break;
      }
    }

    if (this.currentStatusCode === StatementStatus.SENT_TO_FSSP) {
      switch (fieldName) {
        case 'surname':
          name = 'Фамилия нотариуса';
          break;
        case 'firstname':
          name = 'Имя нотариуса';
          break;
        case 'patronymic':
          name = 'Отчество нотариуса';
          break;
        case 'registrationNum':
          name = 'Регистрационный номер Минюста';
          break;
        case 'id':
          name = 'ID заявления';
          break;
        case 'rudsId':
          name = 'Реестровый номер ИН';
          break;
        case 'date':
          name = 'Дата совершения ИН';
          break;
        case 'fssp':
          name = 'Код территориального отделения ФССП';
          break;
        case 'tariff':
          name = 'Тариф';
          break;
        case 'th':
          name = checkIsNewNotaryTariffName(this.statementStatusInfo?.extId)
            ? StatementParam.TH_NEW
            : StatementParam.TH;
          break;
        case 'total':
          name = 'Итого (сумма)';
          break;
        case 'orgName':
          name = 'Наименование организации';
          break;
        case 'inn':
          name = 'ИНН';
          break;
        case 'ogrn':
          name = 'ОГРН';
          break;
        case 'position':
          name = 'Должность нотариуса';
          break;
        case 'recoveryAmount':
          name = 'Сумма взыскания по исполнительной надписи';
          break;
        case 'surnameVrio':
          name = 'Фамилия ВРИО';
          break;
        case 'firstnameVrio':
          name = 'Имя ВРИО';
          break;
        case 'patronymicVrio':
          name = 'Отчество ВРИО';
          break;
      }
    }

    return name;
  }

  // Список полей, которые не показываем
  hideFieldsList(label: string, value: any) {
    return ['privilegesName', 'changedAmount'].includes(label) || !value;
  }
}
